import React, { FC } from 'react';
import InterventionOrder, { InterventionOrderCriteria } from 'src/interfaces/api/InterventionOrder';
import useInterventionOrder from 'src/hooks/api/useInterventionOrder';
import InterventionOrderTable from './InterventionOrderTable';
import { Order } from 'src/interfaces/Table';
import { useNotifier } from 'src/components/NotificationCenter/AlertNotificationCenter';
import { useSetRecoilState } from 'recoil';
import interventionOrders from 'src/recoil/atoms/interventionOrders';

interface Props {
  searchCriteria: InterventionOrderCriteria;
}

const InterventionOrderTableContainer: FC<Props> = (props) => {
  const setInterventionOrders = useSetRecoilState(interventionOrders);
  const { getAll, invoice } = useInterventionOrder();
  const { addNotification } = useNotifier();
  const { searchCriteria } = props;

  const handleInvoiceInterventionOrder = async (
    interventionOrderId: InterventionOrder['id']
  ): Promise<InterventionOrder> => {
    const interventionOrder = await invoice(interventionOrderId);
    setInterventionOrders((orders) => Object.assign({}, orders, { [interventionOrderId]: interventionOrder }));

    addNotification({
      title: "Bon d'intervention facturé !",
      alertProps: { color: 'success' },
    });

    return interventionOrder;
  };

  const handleGetAllInterventionOrder = (
    page: number,
    limit: number,
    orderBy: keyof InterventionOrder,
    order: Order
  ) => {
    return getAll(searchCriteria, page, limit, orderBy, order);
  };

  return (
    <InterventionOrderTable
      onInvoiceInterventionOrder={handleInvoiceInterventionOrder}
      onGetInterventionOrders={handleGetAllInterventionOrder}
    />
  );
};

export default React.memo(InterventionOrderTableContainer);
